export const isWalletConnectedKey = 'walletConnected'

export default isWalletConnectedKey
